module.exports = __webpack_public_path__ + "static/media/AutomationJourney.88f05a7d.png";